import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="text-center mt-5">
      <h1 className="display-1 text-muted">404</h1>
      <p className="lead">Seite nicht gefunden.</p>
      <Link className="btn btn-primary" to="/workouts">Zur Startseite</Link>
    </div>
  );
}
